<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalAssignedVisible" :vm-is-valid="!$v.newRecord.$invalid" vm-title='Assigned project')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=3)
        b-form-group
          vm-input(:danger="$v.newRecord.detailing_weeks.$invalid && $v.newRecord.detailing_weeks.$model" :danger-text="$t('validation.required', { attribute: $t('projects.detailing_weeks') })" v-model="newRecord.detailing_weeks" required type="number")
      vm-col.weeks(vm-justify="center", vm-align="center", vm-w=9)
        span {{ $t('projects.detailing_weeks') }}
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=3)
        b-form-group
          vm-input(:danger="$v.newRecord.approve_shop_drawings_weeks.$invalid && $v.newRecord.approve_shop_drawings_weeks.$model" :danger-text="$t('validation.required', { attribute: $t('projects.approve_shop_drawings_weeks') })" v-model="newRecord.approve_shop_drawings_weeks" required type="number")
      vm-col.weeks(vm-justify="center", vm-align="center", vm-w=9)
        span {{ $t('projects.approve_shop_drawings_weeks') }}
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=3)
        b-form-group
          vm-input(:danger="$v.newRecord.structure_weeks.$invalid && $v.newRecord.structure_weeks.$model" :danger-text="$t('validation.required', { attribute: $t('projects.structure_weeks') })" v-model="newRecord.structure_weeks" required type="number")
      vm-col.weeks(vm-justify="center", vm-align="center", vm-w=9)
        span {{ $t('projects.structure_weeks') }}
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=3)
        b-form-group
          vm-input(:danger="$v.newRecord.joist_weeks.$invalid && $v.newRecord.joist_weeks.$model" :danger-text="$t('validation.required', { attribute: $t('projects.joist_weeks') })" v-model="newRecord.joist_weeks" required type="number")
      vm-col.weeks(vm-justify="center", vm-align="center", vm-w=9)
        span {{ $t('projects.joist_weeks') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("projects.delivery_deadline")' :danger="$v.newRecord.delivery_deadline.$invalid && $v.newRecord.delivery_deadline.$model" :danger-text="$t('validation.required', { attribute: $t('projects.delivery_deadline') })" v-model="newRecord.delivery_deadline")
</template>
<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotes')

export default {
  name: 'ModalAssigned',
  props: {
    newRecord: {
      type: Object
    }
  },
  data: () => ({
    file: ''
  }),
  validations: {
    newRecord: {
      detailing_weeks: {
        required
      },
      approve_shop_drawings_weeks: {
        required
      },
      structure_weeks: {
        required
      },
      joist_weeks: {
        required
      },
      delivery_deadline: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalAssignedVisible'
    ])
  },
  methods: {
    ...mapActions([
      'setModalAssignedVisible',
      'assignedProject'
    ]),
    saveRecord () {
      this.assignedProject({ project: this.newRecord })
    },
    close () {
      this.setModalAssignedVisible(false)
    }
  }
}
</script>
<style scoped>
.weeks {
  padding-left: 20px;
  font-size: 13px;
}
</style>
